import * as THREE from 'three'

const loader = new THREE.TextureLoader()
const cache = new Map()

/**
 * Load (and cache) an sRGB texture for a square plane with CSS `object-fit: cover`
 * behaviour: the image is centred and cropped rather than stretched.
 */
export function loadCoverTexture(url) {
	if (!cache.has(url)) {
		const texture = loader.load(url, () => {
			const { width, height } = texture.image
			const aspect = width / height

			texture.repeat.set(Math.min(1 / aspect, 1), Math.min(aspect, 1))
			texture.offset.set((1 - texture.repeat.x) / 2, (1 - texture.repeat.y) / 2)
			texture.updateMatrix()
		})
		texture.colorSpace = THREE.SRGBColorSpace
		cache.set(url, texture)
	}
	return cache.get(url)
}
